// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

/* Print Styles for Reports */
@media print {
  .no-print {
    display: none !important;
  }
  
  .print-break {
    page-break-before: always;
  }
  
  .print-avoid-break {
    page-break-inside: avoid;
  }
  
  /* Force desktop layout for print */
  .print-optimized {
    font-size: 14px !important;
    max-width: none !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  
  .print-optimized table {
    font-size: 10px !important;
    width: 100% !important;
    table-layout: fixed !important;
  }
  
  .print-optimized th,
  .print-optimized td {
    padding: 4px 6px !important;
    border: 1px solid #e5e7eb !important;
    vertical-align: top !important;
  }
  
  .print-optimized th {
    background-color: #f9fafb !important;
    font-weight: 600 !important;
    font-size: 9px !important;
  }
  
  /* Force desktop container layout */
  .print-optimized .max-w-7xl {
    max-width: none !important;
    margin: 0 !important;
    padding: 20px !important;
  }
  
  /* Hide mobile-specific elements */
  .print-optimized .sm\\\\:hidden {
    display: none !important;
  }
  
  .print-optimized .md\\\\:block {
    display: block !important;
  }
  
  .print-optimized .lg\\\\:block {
    display: block !important;
  }
  
  /* Force table layout to be visible */
  .print-optimized .hidden {
    display: table !important;
  }
  
  .print-optimized .block {
    display: block !important;
  }
  
  body {
    print-color-adjust: exact;
    font-size: 12px !important;
    line-height:1.1 !important;
  }
  
  .bg-gray-50 {
    background-color: white !important;
  }
  
  .shadow {
    box-shadow: none !important;
  }
  
  .rounded-lg {
    border-radius: 0 !important;
  }
  
  /* Ensure tables don't break awkwardly */
  table {
    page-break-inside: avoid;
    border-collapse: collapse !important;
  }
  
  /* Make sure borders are visible in print */
  .border-gray-200 {
    border-color: #e5e7eb !important;
  }
  
  /* Force responsive classes to desktop view */
  .print-optimized .grid {
    display: table !important;
  }
  
  .print-optimized .grid-cols-1 {
    display: table-row !important;
  }
  
  .print-optimized .md\\\\:grid-cols-2 {
    display: table-row !important;
  }
  
  .print-optimized .lg\\\\:grid-cols-3 {
    display: table-row !important;
  }
  
  /* Force card layout to table layout for print */
  .print-optimized .space-y-6 > div {
    display: none !important;
  }
  
  .print-optimized .space-y-6 > div:first-child {
    display: block !important;
  }
  
  /* Show only the table view in print */
  .print-optimized .space-y-6 > div:first-child .overflow-x-auto {
    display: block !important;
  }
  
  .print-optimized .space-y-6 > div:first-child table {
    display: table !important;
    width: 100% !important;
  }
  
  /* Hide card-based layouts in print */
  .print-optimized .space-y-6 > div:not(:first-child) {
    display: none !important;
  }
  
  /* Print utilities */
  .print\\\\:block {
    display: block !important;
  }
  
  .print\\\\:hidden {
    display: none !important;
  }
  
  /* Specific print styles for shared report tables */
  table th {
    font-size: 9px !important;
    padding: 3px 5px !important;
  }
  
  table td {
    font-size: 10px !important;
    padding: 3px 5px !important;
  }
  
  /* Fix line height for property titles in print */
  table td .font-medium {
    line-height: 1.1 !important;
  }
  
  /* Fix line height for property codes */
  table td .text-gray-500 {
    line-height: 1.1 !important;
  }
  
  /* Adjust column widths for print */
  table th:nth-child(1),
  table td:nth-child(1) {
    width: 15% !important;
    max-width: 15% !important;
  }
  
  table th:nth-child(2),
  table td:nth-child(2) {
    width: 25% !important;
    max-width: 25% !important;
  }
  
  /* Reduce overall font size for print */
  body {
    font-size: 11px !important;
  }
  
  h1, h2, h3 {
    font-size: 14px !important;
  }
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,mCAAmC;EACnC;IACE,0BAA0B;IAC1B,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;;IAEE,2BAA2B;IAC3B,oCAAoC;IACpC,8BAA8B;EAChC;;EAEA;IACE,oCAAoC;IACpC,2BAA2B;IAC3B,yBAAyB;EAC3B;;EAEA,mCAAmC;EACnC;IACE,0BAA0B;IAC1B,oBAAoB;IACpB,wBAAwB;EAC1B;;EAEA,kCAAkC;EAClC;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,qCAAqC;EACrC;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IAEE,yBAAyB;IACzB,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA,wCAAwC;EACxC;IACE,wBAAwB;IACxB,oCAAoC;EACtC;;EAEA,2CAA2C;EAC3C;IACE,gCAAgC;EAClC;;EAEA,6CAA6C;EAC7C;IACE,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA,gDAAgD;EAChD;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,sCAAsC;EACtC;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA,qCAAqC;EACrC;IACE,wBAAwB;EAC1B;;EAEA,oBAAoB;EACpB;IACE,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,mDAAmD;EACnD;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA,iDAAiD;EACjD;IACE,2BAA2B;EAC7B;;EAEA,uCAAuC;EACvC;IACE,2BAA2B;EAC7B;;EAEA,mCAAmC;EACnC;;IAEE,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;;IAEE,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA,uCAAuC;EACvC;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n/* Print Styles for Reports */\n@media print {\n  .no-print {\n    display: none !important;\n  }\n  \n  .print-break {\n    page-break-before: always;\n  }\n  \n  .print-avoid-break {\n    page-break-inside: avoid;\n  }\n  \n  /* Force desktop layout for print */\n  .print-optimized {\n    font-size: 14px !important;\n    max-width: none !important;\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n  \n  .print-optimized table {\n    font-size: 10px !important;\n    width: 100% !important;\n    table-layout: fixed !important;\n  }\n  \n  .print-optimized th,\n  .print-optimized td {\n    padding: 4px 6px !important;\n    border: 1px solid #e5e7eb !important;\n    vertical-align: top !important;\n  }\n  \n  .print-optimized th {\n    background-color: #f9fafb !important;\n    font-weight: 600 !important;\n    font-size: 9px !important;\n  }\n  \n  /* Force desktop container layout */\n  .print-optimized .max-w-7xl {\n    max-width: none !important;\n    margin: 0 !important;\n    padding: 20px !important;\n  }\n  \n  /* Hide mobile-specific elements */\n  .print-optimized .sm\\\\:hidden {\n    display: none !important;\n  }\n  \n  .print-optimized .md\\\\:block {\n    display: block !important;\n  }\n  \n  .print-optimized .lg\\\\:block {\n    display: block !important;\n  }\n  \n  /* Force table layout to be visible */\n  .print-optimized .hidden {\n    display: table !important;\n  }\n  \n  .print-optimized .block {\n    display: block !important;\n  }\n  \n  body {\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n    font-size: 12px !important;\n    line-height:1.1 !important;\n  }\n  \n  .bg-gray-50 {\n    background-color: white !important;\n  }\n  \n  .shadow {\n    box-shadow: none !important;\n  }\n  \n  .rounded-lg {\n    border-radius: 0 !important;\n  }\n  \n  /* Ensure tables don't break awkwardly */\n  table {\n    page-break-inside: avoid;\n    border-collapse: collapse !important;\n  }\n  \n  /* Make sure borders are visible in print */\n  .border-gray-200 {\n    border-color: #e5e7eb !important;\n  }\n  \n  /* Force responsive classes to desktop view */\n  .print-optimized .grid {\n    display: table !important;\n  }\n  \n  .print-optimized .grid-cols-1 {\n    display: table-row !important;\n  }\n  \n  .print-optimized .md\\\\:grid-cols-2 {\n    display: table-row !important;\n  }\n  \n  .print-optimized .lg\\\\:grid-cols-3 {\n    display: table-row !important;\n  }\n  \n  /* Force card layout to table layout for print */\n  .print-optimized .space-y-6 > div {\n    display: none !important;\n  }\n  \n  .print-optimized .space-y-6 > div:first-child {\n    display: block !important;\n  }\n  \n  /* Show only the table view in print */\n  .print-optimized .space-y-6 > div:first-child .overflow-x-auto {\n    display: block !important;\n  }\n  \n  .print-optimized .space-y-6 > div:first-child table {\n    display: table !important;\n    width: 100% !important;\n  }\n  \n  /* Hide card-based layouts in print */\n  .print-optimized .space-y-6 > div:not(:first-child) {\n    display: none !important;\n  }\n  \n  /* Print utilities */\n  .print\\\\:block {\n    display: block !important;\n  }\n  \n  .print\\\\:hidden {\n    display: none !important;\n  }\n  \n  /* Specific print styles for shared report tables */\n  table th {\n    font-size: 9px !important;\n    padding: 3px 5px !important;\n  }\n  \n  table td {\n    font-size: 10px !important;\n    padding: 3px 5px !important;\n  }\n  \n  /* Fix line height for property titles in print */\n  table td .font-medium {\n    line-height: 1.1 !important;\n  }\n  \n  /* Fix line height for property codes */\n  table td .text-gray-500 {\n    line-height: 1.1 !important;\n  }\n  \n  /* Adjust column widths for print */\n  table th:nth-child(1),\n  table td:nth-child(1) {\n    width: 15% !important;\n    max-width: 15% !important;\n  }\n  \n  table th:nth-child(2),\n  table td:nth-child(2) {\n    width: 25% !important;\n    max-width: 25% !important;\n  }\n  \n  /* Reduce overall font size for print */\n  body {\n    font-size: 11px !important;\n  }\n  \n  h1, h2, h3 {\n    font-size: 14px !important;\n  }\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
